var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-beam-takt-sum font-weight-light",style:(`
    ${_vm.height?`height: ${_vm.height}; font-size: calc(${_vm.height} - 4px)`:''}
  `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }